import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import heroData from '../data/hero.json';
import businessData from '../data/businessdata.json';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  const { t } = useLanguage();

  const trustItems = [
    { icon: 'ShieldCheck', label: t('hero.trust.licensed') },
    { icon: 'Zap', label: t('hero.trust.sameday') },
    { icon: 'DollarSign', label: t('hero.trust.noFees') }
  ];

  return (
    <section className="pt-32 pb-16 md:pt-48 md:pb-32 overflow-hidden relative bg-paper">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          <div className="w-full lg:w-1/2 flex flex-col items-start z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand/10 text-brand text-sm font-bold mb-6 border border-brand/20">
              <SafeIcon name="Clock" />
              {t('hero.badge')}
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-black text-gray-900 leading-[1.1] mb-6">
              {t('hero.title')}
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-lg leading-relaxed">
              {t('hero.subtitle')}
            </p>
            
            <div className="flex flex-col sm:flex-row w-full sm:w-auto gap-4 mb-8">
              <a 
                href={`tel:${businessData.phoneRaw}`}
                className="flex justify-center items-center gap-2 bg-brand hover:bg-brand-hover text-white px-10 py-5 rounded-full font-bold text-lg transition-all shadow-xl shadow-brand/20 hover:shadow-brand/30 transform hover:-translate-y-1"
              >
                <SafeIcon name="Phone" />
                {t('hero.callBtn')}
              </a>
              <a 
                href={`mailto:${businessData.email}`}
                className="flex justify-center items-center gap-2 bg-white hover:bg-gray-50 text-gray-800 border-2 border-gray-200 px-10 py-5 rounded-full font-bold text-lg transition-all"
              >
                <SafeIcon name="Mail" />
                {t('hero.emailBtn')}
              </a>
            </div>

            {/* Trust Signals Row */}
            <div className="flex flex-wrap gap-y-4 gap-x-6">
              {trustItems.map((item, idx) => (
                <div key={idx} className="flex items-center gap-2 text-gray-500 font-bold text-xs uppercase tracking-wider">
                  <div className="text-brand">
                    <SafeIcon name={item.icon} />
                  </div>
                  {item.label}
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl aspect-[4/3] group ring-8 ring-white">
              <img 
                src={heroData.image} 
                alt="Plumbing Expert" 
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;